import { render, staticRenderFns } from "./kitchenComponent.vue?vue&type=template&id=b547b5a6&scoped=true"
import script from "./kitchenComponent.vue?vue&type=script&lang=js"
export * from "./kitchenComponent.vue?vue&type=script&lang=js"
import style0 from "./kitchenComponent.vue?vue&type=style&index=0&id=b547b5a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b547b5a6",
  null
  
)

export default component.exports